import React, {useState, useEffect} from 'react';
import SelectInterface from '../../forms/SelectInterface.js';
import FieldInterface from './form.js';
import api from '../../../api/index.js';
import {usePrevious, callback} from '../../../helpers.js';


// This should allow you to select a field, a farm, or none
export default (props) => {

	const [fields, setFields] = useState(false);
	const endpoint = 'fields?from=' + new Date(props.from).api() + '&until=' + new Date(props.until).api();


	const refresh = async () => {
		try {
			// If it has changed, it'll already have been invalidated so getsoft() is safe here
			let data = await api.getsoft(endpoint);
			setFields(data);
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	const prevProps = usePrevious(props);

	// Refresh if the date has changed
	useEffect(() => {
		if (!prevProps) return;
		if (fields !== false && (prevProps.from !== props.from || prevProps.until !== props.until)) {
			refresh();
		}
	}, [props]);

	// Refresh on initial load
	useEffect(() => {
		if (fields === false) {
			refresh();
		}

		// If employees have changed, refresh the data
		api.addEventListener('field.change', refresh);
		return ()=>{
			api.removeEventListener('field.change', refresh);
		}
	});


	const onChange = (e) => {
		callback(props.onChange, [e.value])
	}


	const id2value = (farm, field) => {
		if (fields) {
			for(let i=0; i < fields.length; i++) {
				if (fields[i].FarmID === farm && (fields[i].FieldID === field || field === 0 || field === null)) {
					return {
						'value': {'FarmID': farm, 'FieldID': field === null ? 0 : field},
						'label': field === 0 || field === null ? fields[i].FarmName :  ' —›  ' + fields[i].FieldNumber,
						'group': fields[i].FarmName,
						'source': fields[i],
					};
				}
			}
		}
		return {};
	}


	const group = (data) => {
		let groups = {};
		data.forEach((x)=>{
			if (!groups.hasOwnProperty(x.FarmName))
				groups[x.FarmName] = {
					'label': x.FarmName,
					'options': [{
						'value': {'FarmID': x.FarmID, 'FieldID': 0},
						'label': x.FarmName,
						'group': x.FarmName,
						'source': x
					}]
				};
			groups[x.FarmName]['options'].push({
				'value': {'FarmID': x.FarmID, 'FieldID': x.FieldID},
				'label': ' —›  ' + x.FieldNumber,
				'group': x.FarmName,
				'source': x
			});
		});
		let out = [];
		for(let farm in groups) {
			out = out.concat(groups[farm]['options']);
		}
		return out;
	}

	// Search needs to search group
	return <SelectInterface 
		placeholder={props.placeholder || "Field"}
		value={id2value(props.farm, props.field)}
		options={fields ? group(fields) : []}
		type={"Field"}
		onChange={onChange}
		editForm={false}
		addForm={false}
		showClear={props.showClear}
	/>

}
